export const SHOW_LOADING = 'SHOW_LOADING'

export const SIDE_BAR = 'SIDE_BAR'

export const ALERT_DIALOG  = 'ALERT_DIALOG'
export const ALERT_TITLE   = 'ALERT_TITLE'
export const ALERT_CONTENT = 'ALERT_CONTENT'

export const CONFIRM_DIALOG       = 'CONFIRM_DIALOG'
export const CONFIRM_TITLE        = 'CONFIRM_TITLE'
export const CONFIRM_CONTENT      = 'CONFIRM_CONTENT'
export const CONFIRM_YES_TEXT     = 'CONFIRM_YES_TEXT'
export const CONFIRM_NO_TEXT      = 'CONFIRM_NO_TEXT'
export const CONFIRM_YES_VISIBLE  = 'CONFIRM_YES_VISIBLE'
export const CONFIRM_NO_VISIBLE   = 'CONFIRM_NO_VISIBLE'
export const CONFIRM_YES_CALLBACK = 'CONFIRM_YES_CALLBACK'
export const CONFIRM_NO_CALLBACK  = 'CONFIRM_NO_CALLBACK'

// UserInfo
export const USER_INFO    = 'USER_INFO'
export const TOKN         = 'TOKN'
export const USER_ID      = 'USER_ID'
export const USER_NM      = 'USER_NM'
export const ROLE_CD      = 'ROLE_CD'
